import { Badge, Popover, Tooltip } from 'antd';
import _ from 'lodash';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { ResetFilterIcon, RunbookFilterIcon } from "components/Icons";
import { useHistory } from 'react-router-dom';
import FilterBar from './FilterBar';
import { parseURLSearch, updateURLSearch } from 'utils/urlUtil';

const FilterBarWithFilterButton = (props) => {
  const history = useHistory();
  const { location } = history;
  const [filterActive, setFilterActive] = useState();
  const { handleFilterChange, showClearFilters = false } = props;

  useEffect(() => {
    const { filters } = parseURLSearch(location.search);

    const isFilterActive = ((!_.isUndefined(filters) && !_.isEmpty(filters)) || !_.isEmpty(props.filters));
    setFilterActive(isFilterActive);
  }, [location, props.filters]);

  const resetFilters = useCallback(() => {
    if (!filterActive) {
      return;
    }
    if (handleFilterChange) {
      handleFilterChange({});
    } else {
      const { pagination } = parseURLSearch(history.location.search);
      updateURLSearch(history, { pagination, filters: {} });
    }
  }, [history, filterActive, handleFilterChange]);

  if (_.isEmpty(props.filterFields)) {
    return null;
  }
  const content = <>
    <div className='filter-bar-button-reset d-flex justify-content-flex-end' >
      <Tooltip title="Reset Filters"><ResetFilterIcon className={classNames('m-r-xs', 'm-t-xs', { 'disabled': !filterActive, clickable: filterActive  })} onClick={resetFilters} /></Tooltip>
    </div>
    <FilterBar prefixText={props.prefixText} displayType="vertical" columns={props.filterFields} onChange={handleFilterChange} filters={props.filters} />
  </>;
  const filtersLength = _.keys(props.filters).length - (_.has(props.filters, 'searchText') ? 1 : 0);
  return (
    <div className='d-flex'>
      <Popover overlayClassName='filter-by' placement="bottomLeft" content={content} trigger="click" overlayStyle={{ padding: 0 }}>
        <Tooltip title="Filter by">
          <span className={classNames("clickable filter-bar-filter-button d-flex align-items-center", { active: filtersLength > 0 }, props.className)} style={props.style}>
          <Badge size='small' style={{ color: "#35198E", borderColor: "#35198E", backgroundColor: "white" }} count={filtersLength} overflowCount={9}>
            <RunbookFilterIcon fill={filtersLength > 0 ? "#35198E" : "none"} />
            </Badge>
            {props.text ? <>&nbsp;&nbsp;{props.text}</> : null}
          </span>
        </Tooltip>
      </Popover>
      {showClearFilters && filtersLength > 0 && <div className="m-l-xs clickable" style={{ fontSize: 13, height: 13, lineHeight: "13px" }} onClick={resetFilters}>
        Clear Filters
      </div>}
    </div>
  );
};

FilterBarWithFilterButton.defaultProps = {
  text: "Filter By"
}

export default FilterBarWithFilterButton;
